/*! Handmade with love by https://esmes.fi */
var cookies_declined = false;
function CookiebotCallback_OnDecline(){
  console.log('Cookies declined! Remove YouTube popups');
  cookies_declined = true;
  var $ = jQuery;
  $.each($('[data-youtube-id]'), function(i, el){
    $(el).off('click');
    var youtube_id = $(el).attr('data-youtube-id');
    $(el).attr('href', 'https://www.youtube.com/watch?v='+youtube_id);
  });
}

function setAppHeight(){
  document.documentElement.style.setProperty('--app-height', window.innerHeight+'px');
}
window.addEventListener('resize', setAppHeight);
setAppHeight();

let app;

(function($) {

  let App = function(options){
    'use strict';
    let a = this;
  
    //Default configuration, will be overridden with contents from options attribute
    let defaults = {
      targeted_fps: 60, //Targeted fps for animations
      scroll_ontop_treshold: 30, //Treshold for scroll being considered to be on top, in px
      mobile_width: 800,
    };
  
    //Create config from defaults and options, then delete defaults for accidental reference
    a.config = $.extend(true, {}, defaults, options);
    defaults = null;

    a.processHash = function(hash){
      if(hash !== ''){
        log('Process hash: '+hash);
        if(typeof history != "undefined" && typeof history.replaceState != "undefined") {
          history.replaceState(null, null, ' ');
        } else {
          window.location.hash = '';
        }
        let $module = $('[data-anchor="'+hash+'"]');
        if(hash == 'options'){
          $module = $('form.cart');
        }
        if($module.length !== 0){
          log('Hash found');
          var position = 0;
          position = $module.offset().top;
          $('html, body').animate({scrollTop: (position - 20)+'px'}, 600);
        }
      }
    };
  
    //Handles resizing of the window. Will be throttled.
    a.handleResize = function(){
      a.windowWidth = $(window).width();
      a.windowHeight = $(window).height();
      if(a.device == 'mobile' && a.windowWidth > a.config.mobile_width){
        log('Changed to desktop size');
        a.$body.addClass('reload');
        $(window).off('resize');
        window.location.href = window.location.href;
      } else if(a.device == 'desktop' && a.windowWidth <= a.config.mobile_width) {
        log('Changed to mobile size');
        a.$body.addClass('reload');
        $(window).off('resize');
        window.location.href = window.location.href;
      }
    };
  
    //Handles scrolling. Will be throttled.
    a.handleScroll = function(){
      let scroll = $(window).scrollTop();
  
      //Detect if page is scrolled more down than the treshold
      if(scroll > a.config.scroll_ontop_treshold){
        if(a.scrolled === false){
          a.scrolled = true;
          a.$body.addClass('page-scrolled-down');
        }
      } else {
        if(a.scrolled === true){
          a.scrolled = false;
          a.$body.removeClass('page-scrolled-down');
        }
      }
 
      //Calculate change in scroll position
      let scroll_delta = scroll - a.scroll;
  
      //Scroll direction is down
      if(scroll_delta > 0){
        if(a.scroll_direction !== 1){
          a.scroll_direction = 1;
          a.$body.removeClass('page-scroll-direction-up').addClass('page-scroll-direction-down');
        }
      }
      //Scroll direction is up
      if(scroll_delta < 0){
        if(a.scroll_direction !== -1){
          a.scroll_direction = -1;
          a.$body.removeClass('page-scroll-direction-down').addClass('page-scroll-direction-up');
        }
      }

      a.scroll = scroll;
  
    };
  
    a.init = function(){
      if($(window).width() <= a.config.mobile_width){
        a.device = 'mobile';
      } else {
        a.device = 'desktop';
      }

      //Image load
      /*$('img').one('load', function(){
        $(this).addClass('loaded');
      }).each(function() {
        if(this.complete) {
          $(this).trigger('load');
        }
      });*/

      //Youtube popup
      if(!cookies_declined){
        $('.inspiration > [data-youtube-id]').on('click', function(e){
          e.preventDefault();
          var aspect = $(this).attr('data-aspect');
          var youtube_id = $(this).attr('data-youtube-id');
          $('.youtube-popup').attr('data-aspect', aspect);
          var html = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+youtube_id+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
          $('.youtube-popup .youtube-container').html(html);
          $('.youtube-popup').addClass('open');
        });
        $('[role="close-youtube-popup"]').on('click', function(){
          $('.youtube-popup').removeClass('open');
          $('.youtube-popup .youtube-container').html('');
        });
      }

      //Builder
      if(window.custom_product_added_to_cart){
        $('.xoo-wsc-cart-trigger').trigger('click');
      }

      $.each($('a[href^="#builder"]'), function(i, el){
        let href = $(this).attr('href');
        let href_parts = href.split(':');
        const builder_url = 'https://consumer-mirrorline.vividworks.com/?';
        let params = 'cart-id=' + window.wpVars.customer_id + '&nonce=' + window.wpVars.nonce + '&lan='+window.wpVars.language_code;
        if(href_parts[0] && href_parts[0] == '#builder'){
          if(href_parts[1] && href_parts[1] == 'doors'){
            params += '&designmode=doors_only';
          }
          $(this).attr('href', builder_url+params);
          $(this).attr('target', '_blank');
        }
      });
      
      //Move stuff around a bit on mobile
      if(a.device == 'mobile'){
        $('footer .pane.badge').appendTo($('footer .social-links'));
      }

      a.$body = $('body');
  
      //Handle screen resize
      a.handleResize();
      let throttled_resize = throttle(a.handleResize, 1000/a.config.targeted_fps);
      $(window).resize(throttled_resize);
  
      //Handle scroll
      a.scrolled = false;
      a.scroll_direction = 0;
      a.handleScroll();
      let throttled_scroll = throttle(a.handleScroll, 1000/a.config.targeted_fps);
      $(window).scroll(throttled_scroll);

      //Notification bar
      if($('.notification-bar').length){
        let hash = $('.notification-bar').attr('data-hash');
        let notification_bar_closed = localStorage.getItem("notification_bar_closed-"+hash);
        if(!notification_bar_closed){
          $('.notification-bar').show();
          setTimeout(function(){
            let notification_bar_height = $('.notification-bar').outerHeight(); 
            document.documentElement.style.setProperty('--notification-bar-height', notification_bar_height+'px');  
          }, 100);
          $('[role=close-notification-bar]').on('click', function(){
            localStorage.setItem("notification_bar_closed-"+hash, "true");
            $('.notification-bar').remove();
            document.documentElement.style.setProperty('--notification-bar-height', '0px');
          });
        }
      }

      //Campaign popup
      if($('.campaign-popup').length){
        let popup_id = $('.campaign-popup').data('popup-id');
        let popup_closed = sessionStorage.getItem("popup_closed-"+popup_id);
        if(!popup_closed){
          a.$body.addClass('campaign-popup-open');
          $('.campaign-popup [role="close-popup"]').on('click', function(){
            sessionStorage.setItem("popup_closed-"+popup_id, "true");
            a.$body.removeClass('campaign-popup-open');
          });
          $('.campaign-popup .link a').on('click', function(){
            sessionStorage.setItem("popup_closed-"+popup_id, "true");
          });
        }
      }

      //Menu
      $.each($('header .menu-container .menu'), function(i, el){
        $(el).find('.menu-pane-selectors .menu-selector').first().addClass('active');
        $(el).find('.panes .menu-pane').first().addClass('active');
      });
      $('header [role="close-menu"]').on('click', function(e){
        a.$body.removeClass('menu-open');
        $('.active[role="open-menu"]').removeClass('active');
      });
      $('header [role="open-menu"]').on('click', function(){
        if($(this).hasClass('active')){
          $('header .active[role="open-menu"]').removeClass('active');
          a.$body.removeClass('menu-open');
        } else {
          let menu = $(this).attr('data-menu');
          $('header .active[role="open-menu"]').removeClass('active');
          $('header .menu-container .menu.active').removeClass('active');
          $('header .menu-container .menu[data-menu='+menu+']').addClass('active');
          $(this).addClass('active');
          a.$body.addClass('menu-open');
          a.$body.removeClass('search-open');
        }
      });
      $('header .menu-container .menu').on('mouseenter', '.menu-selector', function(el){
        let $menu = $(this).closest('.menu');
        let pane = $(this).attr('data-pane');
        $menu.find('.active[data-pane]').removeClass('active');
        $menu.find('[data-pane='+pane+']').addClass('active');
      });

      /*if(a.$body.hasClass('home') && $('.elements > section.element').first().hasClass('hero') && $('.elements > section.element').first().hasClass('full-background')){
        $('header').addClass('transparent');
      }
      $('header').addClass('loaded');*/

      //Phone menu
      $('header [role="open-mobile-menu"]').on('click', function(e){
        a.$body.addClass('menu-open');
      });
      $('header [role="close-mobile-menu"]').on('click', function(e){
        a.$body.removeClass('menu-open');
        a.$body.find('header .phone-menu').removeClass('pane-active');
        a.$body.find('header .menus.active').removeClass('active');
        a.$body.find('header .menus .menu-pane.active').removeClass('active');
      });
      $('header .phone-menu [role="open-pane"][data-pane]').on('click', function(){
        let pane = $(this).attr('data-pane');
        log(pane);
        a.$body.find('header .phone-menu').addClass('pane-active');
        a.$body.find('header .menus .menu-pane.active').removeClass('active');
        let $pane = a.$body.find('header .menus .menu-pane[data-pane="'+pane+'"]');
        $pane.addClass('active');
        $pane.closest('.menu').addClass('active');
        a.$body.find('header .menus').addClass('active');
      });
      $('header [role="close-pane"]').on('click', function(){
        a.$body.find('header .phone-menu').removeClass('pane-active');
        a.$body.find('header .menu.active').removeClass('active');
        a.$body.find('header .menus.active').removeClass('active');
        a.$body.find('header .menus .menu-pane.active').removeClass('active');
      });

      //Search
      $('header [role="toggle-search"]').on('click', function(e){
        if(a.$body.hasClass('search-open')){
          a.$body.removeClass('search-open');
          $('header input[name="s"]').val('');
        } else {
          a.$body.removeClass('menu-open');
          $('.active[role="open-menu"]').removeClass('active');
          a.$body.addClass('search-open');
          setTimeout(function(){
            $('header input[name="s"]').focus();
          }, 500);
        }
      });

      $('[role="close-header"]').on('click', function(e){
        a.$body.removeClass('menu-open search-open');
        $('.active[role="open-menu"]').removeClass('active');
      });
      
      //Hero split
      if($('.elements > section.hero.split').length){
        let $first_split_hero = $('.elements > section.hero.split').first();
        let updateSplitHeroBackgroundOffset = function(){
          let split_hero_background_offset = 0.5 * ($(window).outerWidth() - $first_split_hero.find('> .hero-container > .wrapper').outerWidth()) + $first_split_hero.find('> .hero-container > .wrapper > .content').outerWidth();
          document.documentElement.style.setProperty('--split-hero-background-offset', split_hero_background_offset+'px');
        }
        updateSplitHeroBackgroundOffset();
        $('.elements > section.hero.split').addClass('calculated');
        window.addEventListener('resize', updateSplitHeroBackgroundOffset);
      }

      //Campaign lift
      if($('.elements > section.campaign-lift').length){
        let $first_campaign = $('.elements > section.campaign-lift').first();
        let updateCampaignBackgroundOffset = function(){
          let campaign_background_offset = 0.5 * ($(window).outerWidth() - $first_campaign.find('> .wrapper').outerWidth()) + $first_campaign.find('> .wrapper > .content').outerWidth();
          document.documentElement.style.setProperty('--campaign-background-offset', campaign_background_offset+'px');
        }
        updateCampaignBackgroundOffset();
        $('.elements > section.campaign-lift').addClass('calculated');
        window.addEventListener('resize', updateCampaignBackgroundOffset);
      }

      //Lightbox
      let lightbox_options = {
        overlayOpacity: 0.5,
        captionSelector: 'img',
        captionType: 'attr',
        captionsData: 'alt',
        captionPosition: 'top', 
        captions: true,
        showCounter: false,
        animationSlide: false,
        fadeSpeed: 100,
        preloading: true,
        scrollZoom: false,
        uniqueImages: false,
        history: false,
        doubleTapZoom: 1,
      }

      a.handleHotspots = function(url){
        log('Handle Hotspots for '+url);
        let html = window.hotspots[url];
        $('.simple-lightbox .sl-image .hotspot').remove();
        $('.simple-lightbox .sl-image .hotspot-content').remove();
        if(typeof html !== "undefined"){
          $('.simple-lightbox .sl-image').append(html);
          setTimeout(function(){ 
            $('.simple-lightbox .sl-image .hotspot').addClass('show'); 
          }, 100); 
        }
      };

      $(document).on('click', '.simple-lightbox .sl-image .hotspot', 'click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if($(this).hasClass('open')){
          $('.simple-lightbox .sl-image .hotspot.open').removeClass('open');
          $('.simple-lightbox .sl-image .hotspot-content').remove();
        } else {
          $('.simple-lightbox .sl-image .hotspot.open').removeClass('open');
          $('.simple-lightbox .sl-image .hotspot-content').remove();
          let $new_content = $(this).find('.content').clone();
          $new_content.addClass('hotspot-content');
          $new_content.appendTo($('.simple-lightbox .sl-image'));
          var left = parseFloat($new_content.attr('data-left'));
          var top = parseFloat($new_content.attr('data-top'));
          if(left > 49) {
            $new_content.addClass('content-on-left');
          }
          if(top > 45) {
            $new_content.addClass('content-on-top');
          }
          if((top > 29 && top <= 45) || (left > 45 && left < 55)){
            $new_content.addClass('content-on-center');
          }
          $new_content.attr('style', 'left: '+left+'%; top: '+top+'%');
          $(this).addClass('open');
        }
      });

      $(document).on('click', '.simple-lightbox .sl-image .hotspot-content .close', 'click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $('.simple-lightbox .sl-image .hotspot.open').removeClass('open');
        $(this).closest('.hotspot-content').remove();
      });

      $(document).on('click', '.simple-lightbox .sl-image .hotspot-content .opener', 'click', function(e){
        e.preventDefault();
        e.stopPropagation();
        let $content = $(this).closest('.hotspot-content');
        if($content.hasClass('open')){
          $content.removeClass('open');
          $content.find('.opener-content').slideUp(400);
        } else {
          $content.addClass('open');
          $content.find('.opener-content').slideDown(400);
        }
      });

      //Inspiration lift
      $.each($('.elements > section.materials, .elements > section.inspiration-lifts, .elements > section.full-width-picture, .elements > section.picture-gallery, .elements > section.inspiration-browser .inspiration, .elements > .product-picture-gallery, .root .product .product-gallery'), function(i, el){
        let $gallery = $(el);
        setTimeout(function(){
          let $lightbox_items = $gallery.find('a.lightbox'); 
          if($lightbox_items.length){
            log('Create gallery');
            let gallery = $lightbox_items.simpleLightbox(lightbox_options);
            gallery.on('shown.simplelightbox', function(e) {
              console.log('opened!');
              a.handleHotspots($(e.srcElement).attr('href'))
            });
            gallery.on('changed.simplelightbox', function(e) {
              console.log('changed!');
              a.handleHotspots($(e.srcElement).attr('href'))
            });
          }
        }, 100);
      });

      //Inspiration browser
      $.each($('.elements > section.inspiration-browser'), function(i, el){
        log('Create isotope');
        let $that = $(el);
        let $inspirations = $that.find('.inspirations');

        let lightbox = false;
        let $carousel = $that.find('.picture-gallery-carousel');
        let has_separated_images = $carousel.length !== 0;

        $inspirations.append($('<div class="grid-sizer"></div>'));
        let $grid = $inspirations.isotope({
          itemSelector: '.inspiration',
          //layoutMode: 'fitRows',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
        let updateFilters = function(){
          let product_filter = $that.find('.filters[data-filter="product"] .filter.active').attr('data-product');
          let room_filter = $that.find('.filters[data-filter="room"] .filter.active').attr('data-room');

          log(product_filter);
          log(room_filter);
          if(product_filter == 'all') product_filter = '';
          if(room_filter == 'all') room_filter = '';

          let filter = '';
          if(product_filter != '') filter += '.product-'+product_filter
          if(room_filter != '') filter += '.room-'+room_filter;
          if(filter == '') filter = '.inspiration';

          log('filter:');
          log(filter);

          $grid.isotope({filter: filter});

          //If we have separate image browser
          if(has_separated_images){
            if(filter !== '.inspiration'){
              $carousel.find('.item').addClass('hidden');
              $carousel.find('.item'+filter).removeClass('hidden');
            } else {
              $carousel.find('.item.hidden').removeClass('hidden');
            }
            $carousel.removeClass('has-prev has-next');
            $carousel[0].style.setProperty('--current-item', 0);
            if($carousel.find('.item').not('.hidden').length > 0){
              $carousel.addClass('has-next');
            }
            if($carousel.find('.item').not('.hidden').length == 0){
              $that.find('.image-browser').hide();
            } else {
              $that.find('.image-browser').show();
            }
            
            //Destroy old lightbox
            if(lightbox !== false) {
              lightbox.destroy();
              lightbox = false;
            } 

            //Create new lightbox if we have visible items
            let $lightbox_items = $carousel.find('.item:not(.hidden) a.lightbox'); 
            if($lightbox_items.length){
              log('Create gallery');
              lightbox = $lightbox_items.simpleLightbox(lightbox_options);
              lightbox.on('shown.simplelightbox', function(e) {
                console.log('opened!');
                a.handleHotspots($(e.srcElement).attr('href'))
              });
              lightbox.on('changed.simplelightbox', function(e) {
                console.log('changed!');
                a.handleHotspots($(e.srcElement).attr('href'))
              });
            }
            
          }

        };
        $(el).on('click', '.filter:not(.active)', function(e){
          $(this).closest('.filters').find('.filter.active').removeClass('active');
          $(this).addClass('active');
          updateFilters();
        });
        updateFilters();
      });

      //Picture carousel
      a.initPictureCarousel = function($carousel){
        let onCarouselResize = function(){
          let product_width = $carousel.find('.item').first().outerWidth();
          $carousel[0].style.setProperty('--item-width', product_width+'px');
        }
        onCarouselResize();
        $(window).resize(onCarouselResize);
        let item_count = $carousel.find('.item:not(.hidden)').length;
        if(item_count <= 3){
          $carousel.addClass('hide-controllers');
        }
        if(item_count > 1){
          $carousel.addClass('has-next');
        }
        $carousel.find('.controller').on('click', function(i, el){
          let current = parseInt($carousel.css('--current-item'), 10);
          let next;
          let item_count = $carousel.find('.item:not(.hidden)').length;
          if($(this).hasClass('right')){
            next = current+1;
          } else {
            next = current-1;
          }
          //Limit
          if(next < 0) next = 0;
          if(next >= item_count) {
            next = item_count - 1;
          }
          //Set current
          $carousel[0].style.setProperty('--current-item', next);
          //Adjust controller visibility
          if(item_count > 1 && next < (item_count - 1)){
            $carousel.addClass('has-next');
          } else {
            $carousel.removeClass('has-next');
          }
          if(next > 0){
            $carousel.addClass('has-prev');
          } else {
            $carousel.removeClass('has-prev');
          }
        });
      }
      $.each($('.picture-gallery-carousel'), function(i, el){
        a.initPictureCarousel($(el));
      });

      //Reorganise cart form
      $.each($('form.cart'), function(i, el){
        let $cart = $(el);
        let $product = $cart.closest('.product');
        let $cart_wrapper = $('<div class="cart-wrapper"></div>');
        $cart_wrapper.appendTo($cart);
        $cart.find('.quantity').appendTo($cart_wrapper);

        //Process option selections
        $.each($('.wc-pao-addon-container'), function(i, el){
          let $container = $(el);
          let $label = $container.find('> label');

          if($label.length){
            let label = $.trim($label.text());

            //If we have a option selector...
            let split_label = label.split('#');
            if(split_label.length == 2){
              let split_option = split_label[1].split(':');
              if(split_option.length == 2){
                label = split_label[0];
                $label.html(label);
                $label.attr('data-addon-name', label);
                $container.addClass('select-option');
                $container.attr('data-option', split_option[0]);
                $container.attr('data-option-value', split_option[1]);
                $container.hide();
              }
            }

          }
        });

        if($cart.find('.wc-pao-addon').length){
          let $addons_total = $('#product-addons-total');
          $addons_total.wrap('<div class="product-price-container"></div>');
          $product.addClass('wc-pao-addon');
          /*let $sale_price = $product.find('.entry-summary > .price > del');
          if($sale_price.length){
            log('Sale price found!');
            $sale_price.prependTo($addons_total.parent());
          }*/
          $addons_total.parent().appendTo($cart_wrapper);
        } else {
          let $price = $product.find('.price');
          $price.appendTo($cart_wrapper);

        }

        if($product.hasClass('contact-form-product')){
          console.log('CONTACT FORM PRODUCT!');
          $cart.find('.single_add_to_cart_button').remove();

          var $contact_form_button = $('<button class="button" role="toggle-contact-form">'+window.wpVars.language.get_quote+'</button>');
          $contact_form_button.appendTo($cart_wrapper);

          $('[role="toggle-contact-form"]').on('click', function(e){
            e.preventDefault();
            if($(this).hasClass('active')){
              $(this).removeClass('active');
              $('.product-contact-form-wrapper').slideUp(500);
            } else {
              $(this).addClass('active');
              $('.product-contact-form-wrapper').slideDown(500);
            }
          }); 

        } else {
          $cart.find('.single_add_to_cart_button').appendTo($cart_wrapper);
        }

        $.each($cart.find('.wc-pao-addon-description'), function(i, el){
          if($(el).prev().is('label.wc-pao-addon-name')){
            $(el).appendTo($(el).prev());
          }
        });

        $.each($cart.find('.wc-pao-addon-image-swatch'), function(i, el){
          var text = $(el).find('img').attr('alt');
          text = text.replace(/\s/g, ' ');
          text = text.replace(' 0,00 €', '');
          text = text.replace(' 0,00 kr', '');
          $(el).append($('<div class="phone-label">'+$.trim(text)+'</div>'));
        });

        //Process required PAO
        $.each($('.wc-pao-required-addon'), function(i, el){
          if($(el).find('a.wc-pao-addon-image-swatch').length){
            //Activate first image swatch
            $(el).find('a.wc-pao-addon-image-swatch').first().trigger('click');
          }
        });

        setTimeout(function(){$product.addClass('cart-processed');}, 200);
      });

      $('.wc-pao-addon-image-swatch').closest('.wc-pao-addon-wrap').addClass('has-image-swatches');

      if($('form.cart').length && $('.small-product-links').length){
        $('.small-product-links').prependTo($('form.cart'));
        $('.small-product-links').show();
      }

      $('.accordion [role="open-accordion"]').on('click', function(e){
        let $accordion = $(this).closest('.accordion');
        if($accordion.hasClass('open')){
          $accordion.removeClass('open');
          $accordion.find('.accordion-content').slideUp(500);
        } else {
          $accordion.addClass('open');
          $accordion.find('.accordion-content').slideDown(500);
        }
      });

      a.updateCustomMultipleSelectInputs = function(){
        if(typeof window.multiple_select_items != 'undefined'){
          $.each($('form.cart .input-text.wc-pao-addon-field'), function(i, el){
            let $el = $(el);
            let $label = $el.closest('.wc-pao-addon-container').find('label');
            $label.removeAttr('for');
            let title = $label.attr('data-addon-name');
            if(typeof window.multiple_select_items[title] != "undefined" && !$el.parent().hasClass('custom-multiple-select-input')){
              var items = window.multiple_select_items[title];
              $el.wrap($('<div class="custom-multiple-select-input"></div>'));
              let selectors_html = '';
              $.each(items, function(i, item){
                selectors_html += '<div class="multiple-select" data-value="'+item.text+'"><div class="tooltip">'+item.text+'</div><img src="'+item.img+'"/><div class="phone-label">'+item.text+'</div></div>';
              });
              $el.closest('.custom-multiple-select-input').append($('<div class="multiple-selects"><div class="multiple-select clear-select" data-value="'+window.wpVars.language.none+'"><div class="tooltip">'+window.wpVars.language.none+'</div><img src="'+window.wpVars.image_missing+'"/><div class="phone-label">'+window.wpVars.language.none+'</div></div>'+selectors_html+'</div>'));
              $el.closest('.custom-multiple-select-input').find('.multiple-selects .multiple-select').on('click', function(){
                if($(this).hasClass('clear-select')){
                  $(this).closest('.multiple-selects').find('.multiple-select.selected').removeClass('selected');
                  $(this).addClass('selected');
                } else {
                  if($(this).hasClass('selected')){
                    $(this).removeClass('selected');
                    if($(this).closest('.multiple-selects').find('.multiple-select.selected').length === 0){
                      $(this).closest('.multiple-selects').find('.multiple-select.clear-select').addClass('selected');
                    }
                  } else {
                    $(this).closest('.multiple-selects').find('.multiple-select.clear-select').removeClass('selected');
                    if($(this).closest('.multiple-selects').find('.multiple-select.selected').length < window.multiple_select_max_amount){
                      $(this).addClass('selected');
                    } else {
                      var message = window.wpVars.language.max_number.replace('[number]', window.multiple_select_max_amount);
                      alert(message);
                    }
                  }
                }
                let $selected = $(this).closest('.multiple-selects').find('.multiple-select.selected');
                let selected_values = [];
                $.each($selected, function(j, selected_el){
                  selected_values.push($(selected_el).attr('data-value'));
                })
                $el.val(selected_values.join(', '));
                log(selected_values.join(', '));
              });
              $el.closest('.custom-multiple-select-input').find('.multiple-selects .multiple-select.clear-select').trigger('click');
            }
          });
        }
      };
      a.updateCustomMultipleSelectInputs();

      //Custom number input
      a.updateNumberInputs = function(){
        $.each($('form.cart .quantity input[type="number"], .cart_item .quantity input[type="number"]'), function(i, el){
          let $el = $(el);
          $el.data('timer', false);
          if(!$el.parent().hasClass('custom-number-input')){
            $el.wrap($('<div class="custom-number-input"></div>'));
            $el.closest('.custom-number-input').append($('<div class="controller less">-</div><div class="value">'+$el.val()+'</div><div class="controller more">+</div>'));
            let step = parseInt($(el).attr('step'), 10);
            let min = parseInt($(el).attr('min'), 10);
            let max = parseInt($(el).attr('max'), 10);
            let initial_value = parseInt($(el).val(), 10);
            let $value = $el.closest('.custom-number-input').find('.value');
            if(initial_value > min){
              $el.closest('.custom-number-input').addClass('has-less');
            }
            if(isNaN(max) || (!isNaN(max) && initial_value < max)){
              $el.closest('.custom-number-input').addClass('has-more');
            }
            $el.closest('.custom-number-input').find('.controller').on('click', function(){
              let current_value = parseInt($(el).val(), 10);
              var delta = 0;
              if($(this).hasClass('less')){
                delta = -1 * step;
              } else if($(this).hasClass('more')){
                delta = step;
              }
              let new_value = current_value + delta;
              if(new_value < min) { new_value = min; }
              if(!isNaN(max) && new_value > max){ new_value = max }
              log('new value: '+new_value);
              
              if($el.data('timer') !== false){
                log('Clear change timer');
                clearTimeout($el.data('timer'));
                $el.data('timer', false);
              }
              
              var timer = setTimeout(function(){
                log('Run change after delay');
                $el.val(new_value).change();
                $el.data('timer', false);
              }, 300);
              $el.data('timer', timer);

              if(new_value > min){
                $el.closest('.custom-number-input').addClass('has-less');
              } else {
                $el.closest('.custom-number-input').removeClass('has-less');
              }
              if(isNaN(max) || (!isNaN(max) && new_value < max)){
                $el.closest('.custom-number-input').addClass('has-more');
              } else {
                $el.closest('.custom-number-input').removeClass('has-more');
              }
              $value.html(new_value);
            });
          }
        });
      }
      
      a.updateNumberInputs();
      
      a.$body.on('updated_cart_totals', a.updateNumberInputs);

      //Custom select input 
      $.each($('form.cart select:not(.wc-pao-addon-image-swatch-select):not([name^="attribute_"])'), function(i, el){
        let $el = $(el);
        if($el.find('option').length > 4){
          
          $el.data('timer', false);

          let values = [];
          $.each($el.find('option[value][data-label]'), function(i, option){
            let value = $(option).attr('value');
            let label = $(option).attr('data-label') || '';
            values.push({value: value, label: label});
          });
          $el.wrap($('<div class="custom-range-input"></div>'));
          let $custom_input = $el.closest('.custom-range-input');
          $custom_input.append($('<div class="controller less">-</div><div class="track"><div class="bar"></div><div class="label">'+values[0].label+'</div></div><div class="controller more">+</div>'));
          let $label = $el.closest('.custom-range-input').find('.label');
          let label_width = 0;
          let $track = $el.closest('.custom-range-input').find('.track');
          let track_width = 0;
          let current_index = 0;
          let offset = false;
          let updateRangeInputSizes = function(){
            track_width = $track.width();
            label_width = $label.outerWidth();
            offset = $track.offset();
            updateRangeInputPosition();
          };
          $(window).resize(updateRangeInputSizes);
          let updateRangeInputPosition = function(){
            let min = 0.5*label_width;
            let range = track_width-label_width;
            let position_ratio = (current_index/(values.length-1));
            var pixel_value = position_ratio * range + min;
            $track[0].style.setProperty('--bar-position', pixel_value+'px');
          };
          let getIndexByPixelValue = function(pixel){
            let index = Math.floor((pixel - 0.5*label_width) / (track_width - label_width) * (values.length - 1));
            return index;
          }
          let updateRangeInputValue = function(new_index){
            if(new_index > 0){
              $el.closest('.custom-range-input').addClass('has-less');
            } else {
              $el.closest('.custom-range-input').removeClass('has-less');
            }
            if(new_index < values.length - 1){
              $el.closest('.custom-range-input').addClass('has-more');
            } else {
              $el.closest('.custom-range-input').removeClass('has-more');
            }
            current_index = new_index;
            let new_data = values[current_index];
            if(typeof new_data == "undefined") log('err: '+current_index);

            if($el.data('timer') !== false){
              log('Clear change timer');
              clearTimeout($el.data('timer'));
              $el.data('timer', false);
            }
            
            var timer = setTimeout(function(){
              log('Run change after delay');
              $el.val(new_data.value).change();
              $el.data('timer', false);
            }, 300);
            $el.data('timer', timer);

            $label.html(new_data.label);
            updateRangeInputSizes();
            updateRangeInputPosition();
          };
          $el.closest('.custom-range-input').find('.controller').on('click', function(){
            var delta = 0;
            if($(this).hasClass('less')){
              delta = -1;
            } else if($(this).hasClass('more')){
              delta = 1;
            }
            let new_index = current_index + delta;
            if(new_index < 0) { new_index = 0; }
            if(new_index >= values.length - 1){ new_index = values.length - 1; }
            updateRangeInputValue(new_index);
          });
          let dragging = false;
          let startDragging = function(e){
            dragging = true;
            $custom_input.removeClass('animate');
          };
          let stopDragging = function(e){
            e.preventDefault();
            e.stopPropagation();
            dragging = false;
            $custom_input.addClass('animate');
          };
          let dragMove = function(e){
            if(dragging) {
              let pagex = e.pageX || e.touches[0].pageX;
              let x_pos = pagex - offset.left;
              if(x_pos < 0.5*label_width) x_pos = 0.5*label_width;
              if(x_pos > track_width-0.5*label_width) x_pos = track_width-0.5*label_width;
              let index = getIndexByPixelValue(x_pos);
              updateRangeInputValue(index);
            }
          };
          $label.on('mousedown touchstart', startDragging);
          $label.on('mouseleave ', stopDragging);
          $label.on('mouseup touchend', stopDragging);
          $track.on('mouseup touchend', stopDragging);
          $track.on('mousemove touchmove', dragMove);
          $label.on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
          });
          $track.on('click', function(e){
            let x_pos = e.pageX - offset.left;
            if(x_pos < 0.5*label_width) x_pos = 0.5*label_width;
            if(x_pos > track_width-0.5*label_width) x_pos = track_width-0.5*label_width;
            let index = getIndexByPixelValue(x_pos);
            updateRangeInputValue(index);
          });
          updateRangeInputSizes();
          updateRangeInputValue(current_index);
          $custom_input.addClass('animate');
        } else {
          $el.wrap($('<div class="custom-toggle-input"></div>'));
          let $custom_input = $el.closest('.custom-toggle-input');
          let input_html = '';

          $.each($el.find('option[value][data-label]'), function(i, option){
            let value = $(option).attr('value');
            let label = $(option).attr('data-label');

            let option_selector = '';
            let option_value = '';

            //If we have a option selector...
            let split_label = label.split('#');
            if(split_label.length == 2){
              let split_option = split_label[1].split(':');
              if(split_option.length == 2){
                option_selector = split_option[0];
                option_value = split_option[1];
                label = split_label[0];
                $(option).html(label);
              }
            }

            input_html += '<div class="selector'+(label.length > 12 ? ' small' : '')+'" data-value="'+value+'"'+(option_selector != '' && option_value != '' ? ' data-option="'+option_selector+'" data-option-value="'+option_value+'"': '')+'>'+label+'</div>';
          
          });

          $custom_input.append('<div class="selectors">'+input_html+'</div>');
          $custom_input.find('.selector[data-value]').on('click', function(e){
            $custom_input.find('.selector.active').removeClass('active');
            let value = $(this).attr('data-value');
            $el.val(value).change();
            if($(this).attr('data-option') && $(this).attr('data-option-value')){
              let data_option = $(this).attr('data-option');
              let data_option_value = $(this).attr('data-option-value');
              //Clear old values
              $.each($(this).closest('form.cart').find('.select-option[data-option="'+data_option+'"] .selectors .selector:first-child'), function(i, el){
                $(el).trigger('click');
              });
              //Set new value
              $(this).closest('form.cart').find('.select-option[data-option="'+data_option+'"]').hide();
              $(this).closest('form.cart').find('.select-option[data-option="'+data_option+'"][data-option-value="'+data_option_value+'"]').show();
            }
            $(this).addClass('active');
          });
          $custom_input.find('.selector').first().trigger('click');
        }
      });

      //Custom checkbox input 
      $.each($('form.cart .wc-pao-addon-container'), function(i, el){
        let $el = $(el);
        if($el.find('input[type="checkbox"]').length){
          let $checkbox_container = $('<div class="custom-checkbox-input"></div>');
          $el.closest('.wc-pao-addon-container').append($checkbox_container);
          $el.find('input[type="checkbox"]').closest('div.form-row > div').addClass('custom-checkbox-item').appendTo($checkbox_container);
          $el.find('div.form-row').remove();
          $el.find('div.custom-checkbox-item label').wrapInner($('<span></span>')).wrap($('<div class="custom-checkbox"></div>'));
          $.each($(el).find('.custom-checkbox > label > span'), function(i, span){
            let $span = $(span);
            let cleaned_label = $.trim($span.text().replace(/ *\([^)]*\) */g, ""));
            $span.html(cleaned_label);
          });
        }
      });

      //PAO number input
      $.each($('form.cart .wc-pao-addon-container input[type="number"]'), function(i, el){
        let $el = $(el);
        if(!$el.parent().hasClass('custom-number-input')){
          let $label = $el.closest('.wc-pao-addon-container').find('.wc-pao-addon-name');
          $label.html($label.attr('data-addon-name'));
          let initial_value = parseInt($(el).val(), 10);
          if(isNaN(initial_value)) initial_value = 0;
          $el.wrap($('<div class="custom-number-input"></div>'));
          $el.closest('.custom-number-input').append($('<div class="controller less">-</div><div class="value">'+initial_value+'</div><div class="controller more">+</div>'));
          let step = parseInt($(el).attr('step'), 10);
          if(isNaN(step)) step = 1;

          let restrictions = JSON.parse($(el).attr('data-restrictions'));
          //console.log('restrictions', restrictions);

          let parsed_min = parseInt($(el).attr('min'), 10);
          let parsed_max = parseInt($(el).attr('max'), 10);

          let min = 0;
          let max = parsed_max;

          if(!isNaN(parsed_min)){
            min = parsed_min; 
          }

          if(restrictions.min) {
            min = restrictions.min;
          }

          if(restrictions.max) {
            max = restrictions.max;
          }

          //console.log('min', min);
          //console.log('max', max);

          let $value = $el.closest('.custom-number-input').find('.value');
          if(initial_value > min){
            $el.closest('.custom-number-input').addClass('has-less');
          }
          if(isNaN(max) || (!isNaN(max) && initial_value < max)){
            $el.closest('.custom-number-input').addClass('has-more');
          }
          $el.closest('.custom-number-input').find('.controller').on('click', function(){
            let current_value = parseInt($el.val(), 10);
            if(isNaN(current_value)) current_value = 0;
            var delta = 0;
            if($(this).hasClass('less')){
              delta = -1 * step;
            } else if($(this).hasClass('more')){
              delta = step;
            }
            let new_value = current_value + delta;
            if(new_value < min) { new_value = min; }
            if(!isNaN(max) && new_value > max){ new_value = max }
            log('new value: '+new_value);
            
            $el.val(new_value).change();

            if(new_value > min){
              $el.closest('.custom-number-input').addClass('has-less');
            } else {
              $el.closest('.custom-number-input').removeClass('has-less');
            }
            if(isNaN(max) || (!isNaN(max) && new_value < max)){
              $el.closest('.custom-number-input').addClass('has-more');
            } else {
              $el.closest('.custom-number-input').removeClass('has-more');
            }
            $value.html(new_value);
          });
        }
      });

      if($('.product.contact-form-product').length && $('.gfield.product-details-input textarea').length){
        console.log('We have a contact form product!');

        var processProductData = function(){
          log('Processing ProductData');
          var text = '';

          $.each($('.wc-pao-addon-container'), function(i, el){
            var $el = $(el);
            text += $el.find('.wc-pao-addon-name').attr('data-addon-name')+': ';
            if($el.find('.wc-pao-addon-image-swatch').length){
              //Swatches
              var data = [];
              $.each($el.find('.wc-pao-addon-image-swatch.selected'), function(i, input){
                //var $text_element = $($(input).attr('data-price'));
                //data.push($text_element.text());
                var alt_text = $(input).find('img').attr('alt');
                data.push(alt_text);
              });
              text += data.join(', ');
            } else if($el.find('.wc-pao-addon-checkbox').length){
              //Checkboxes
              var data = [];
              $.each($el.find('.wc-pao-addon-checkbox:checked'), function(i, input){
                data.push($(input).attr('data-label'));
              });
              text += data.join(', ');
            } else if($el.find('.wc-pao-addon-input-multiplier').length){
              //Number inputs
              text += $.trim($el.find('input.wc-pao-addon-input-multiplier').val());
            } else if($el.find('.wc-pao-addon-select').length){
              //Selects
              text += $.trim($el.find('select.wc-pao-addon-select option:selected').text());
              log(text);
            }
            text += "\r\n";
          });

          text += window.wpVars.language.price_from+': '+$('.product-addon-totals .price .amount').text();

          $('.gfield.product-details-input textarea').val(text);
        };

        //Trigger updates
        $.each($('form.cart .wc-pao-addon-container'), function(i, el){
          $(el).on('change', function(e){
            console.log('CHANGE HAPPENED '+Date.now());
            setTimeout(function(){
              processProductData();
            }, 100);
          });
        });
        $('.wc-pao-addon-image-swatch').on('click', function(){
          console.log('SWATCH CHANGE HAPPENED '+Date.now());
          var $swatch = $(this);
          setTimeout(function(){
            processProductData();
          }, 100);
        });
      }

      
      //Hash functions
      var hash = window.location.hash;
      if(hash.charAt(0) == '#' && hash.length > 1) {
        setTimeout(function(){
          a.processHash(hash.substring(1));
        }, 300);
      }
      $(window).on('hashchange', function(e){
        var hash = window.location.hash;
        if(hash.charAt(0) == '#' && hash.length > 1) {
          a.processHash(hash.substring(1));
        }
      });

      a.$body.on('adding_to_cart', function(){
        log('adding_to_cart');
      });

      $(document).on('click', '.dropdown .dropdown-toggle', function(){
        if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).closest('.dropdown').find('.dropdown-menu').removeClass('show');
        } else {
          $(this).addClass('active');
          $(this).closest('.dropdown').find('.dropdown-menu').addClass('show');
        }
      });
  
      $(document).on('click', '.dropdown .dropdown-close', function(e){
        e.preventDefault();
        e.stopPropagation();
        let $dropdown = $(this).closest('.dropdown');
        $dropdown.find('.dropdown-toggle').removeClass('active');
        $dropdown.find('.dropdown-menu').removeClass('show');
      });
  
      $('#wpsl-search-submit').on('click', function(e){
        $('#wpsl-search-btn').trigger('click');
      });
  
      $(document).on('change', '.wpsl-category-filters input', function(e){
        $('#wpsl-search-btn').trigger('click');
      });
      
      $(document).on('click', '#wpsl-toggle-btn', function(e){
        if($(this).hasClass('active')){
          $(this).removeClass('active');
          $('#wpsl-stores').removeClass('show');
        } else {
          $(this).addClass('active');
          $('#wpsl-stores').addClass('show');
        }
      });
  
      if(a.device == 'mobile'){
        //Move wpsl result location
        $('#wpsl-result-list').appendTo($('#wpsl-wrap'));
      }
  
      //Open shipping calculator
      $.each($('.shipping-calculator-form:not(:visible)'), function(i, el){
        log('Form not visible');
        $(this).prev('a.shipping-calculator-button').trigger('click');
      });

      $.each($('iframe[deferred-src]'), function(i, el){
        log('Process deferred iframes');
        let src = $(el).attr('deferred-src');
        $(el).removeAttr('deferred-src');
        $(el).attr('src', src);
      });

      //Check disabled iframes
      $.each($('.booking iframe[data-cookieblock-src]'), function(i, el){
        let $iframe = $(el);
        let src = $iframe.attr('data-cookieblock-src');
        $iframe.replaceWith($('<div class="no-cookies"><a href="'+src+'" target="_blank">'+window.wpVars.language.no_cookie_iframe+'</a></div>'));
      });

      $.each($('.youtube-placeholder[data-youtube-id]'), function(i, el){
        let youtube_id = $(el).attr('data-youtube-id');
        $(el).on('click', function(e){
          e.preventDefault();
          let html = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+youtube_id+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
          $(el).append(html);
          $(el).off('click');
        });
      });

      $.each($('.embed-wrap'), function(i, el){
        let $placeholder = $(el).find('a.embed-wrap__placeholder');
        let $iframe = $placeholder.parent().find('iframe');
        if(!$iframe.attr('src')){
          //let src = $iframe.attr('data-cookieblock-src');
          let src = $iframe.attr('data-lazy-src');
          if(src){
            let link = src;
            let src_parts;
            if(src.includes('youtube.com') || src.includes('youtu.be')){
              log('Processing YouTube embed');
              $placeholder.addClass('--youtube');
              let src_parts = src.split('?');
              link = src_parts[0];
              link = link.replace('/embed/', '/watch?v=');
              let id = link.split('/watch?v=');
              id = id[1];
              $placeholder.get(0).style.setProperty("--background-image", 'url(\''+window.wpVars.home_url+'?embed_id='+id+'&type=youtube\')');
              $placeholder.on('click', function(e){
                if(!cookies_declined){
                  e.preventDefault();
                  $iframe.replaceWith('<iframe width="980" height="551" src="https://www.youtube.com/embed/'+id+'?autoplay=1&feature=oembed&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
                }
              });
            } else if(src.includes('vimeo.com')){
              log('Processing Vimeo embed');
              $placeholder.addClass('--vimeo');
              let src_parts = src.split('?');
              link = src_parts[0];
              src_parts = link.split('/');
              let id = src_parts[src_parts.length-1];
              $placeholder.get(0).style.setProperty("--background-image", 'url(\''+window.wpVars.home_url+'?embed_id='+id+'&type=vimeo\')');
              link = 'https://vimeo.com/'+id;
            } 
            $placeholder.attr('target', '_blank');
            $placeholder.attr('href', link);
          }
          $placeholder.addClass('--processed');
        }
      });

      //Hero background video
      $.each($('.elements > section.hero video'), function(i, video_el){
        //Check if readystate is already high enough
        if(video_el.readyState >= 3){
          $(video_el).parent().addClass('video-playing');
        } else {
          //Attach to canplay events
          $(video_el).on('canplay canplaythrough', function(){
            $(video_el).parent().addClass('video-playing');
          });
        }
      });

    };
  
    a.init();
  
  };

  $(document).ready(function(){

    app = new App();
  
  });
 
}(jQuery));

// === Helper functions

function log(obj) {
  if (window.wpVars.debug && console && console.log) {
    console.log(obj);
  }
}

//Returns a function, that, when invoked, will only be triggered at most once
//during a given window of time. Normally, the throttled function will run
//as much as it can, without ever going more than once per `wait` duration;
//but if you'd like to disable the execution on the leading edge, pass
//`{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  let context, args, result;
  let timeout = null;
  let previous = 0;
  if (!options) options = {};
  let later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    let now = Date.now();
    if (!previous && options.leading === false) previous = now;
    let remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}
